import { Component, ElementRef, Inject, OnInit, Renderer2 } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FilterService } from 'src/app/services/filter.service';

@Component({
  selector: 'app-bottom-grid-sheet',
  templateUrl: './bottom-grid-sheet.component.html',
  styleUrls: ['./bottom-grid-sheet.component.scss']
})
export class BottomGridSheetComponent implements OnInit {
  
  widgetConfig:any;
  isExpanded = false;
  paramsData:any;
  pageKey:any;
  selectedHeader = ''
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public passedData: any,
    private bottomSheetRef: MatBottomSheetRef<BottomGridSheetComponent>,
    private renderer: Renderer2,
    private el: ElementRef,
    private filterService: FilterService
  ) { 
    this.paramsData = passedData
  }


  ngOnInit(): void {
    // console.log(this.paramsData);
    const td = this.paramsData?.tooltipData;
    this.selectedHeader = td?.name ? `${td.groupName} - ${td.name}` : td?.groupName || '';

    this.widgetConfig = this.paramsData?.widgetInfo?.newItemConfig || '';
    this.pageKey = this.paramsData?.pageKey || '';
    
    setTimeout(() => {
      this.filterService.treeMapSingleClickTrigger.next(this.paramsData.obj);
    }, 500);
  }

  close(): void {
    this.bottomSheetRef.dismiss();
  }

  toggleExpand(): void {
    this.isExpanded = !this.isExpanded;
    const container = this.el.nativeElement.closest('.mat-bottom-sheet-container');

    if (container) {
      if (this.isExpanded) {
        this.renderer.setStyle(container, 'height', '95vh');
        this.renderer.setStyle(container, 'max-height', '95vh');
        this.renderer.setStyle(container, 'width', '90vh');
        this.renderer.setStyle(container, 'border-radius', '10');
      } else {
        this.renderer.removeStyle(container, 'height');
        this.renderer.removeStyle(container, 'max-height');
        this.renderer.removeStyle(container, 'width');
        this.renderer.removeStyle(container, 'border-radius');
      }
    }
  }


}
